import React from "react";
import classes from "./BenefitsPopUp.module.scss";

export interface BenefitItemProps {
   title: string;
   description: string;
   icon: React.ReactElement;
}

const BenefitItem: React.FC<BenefitItemProps> = ({ title, description, icon }) => {
   return (
      <div className={classes.benefitItem}>
         <div className={classes.benefitItemIcon}>
            {React.cloneElement(icon)}
         </div>
         <div className={classes.benefitItemContent}>
            <span className={classes.benefitItemTitle}>{title}</span>
            <span className={classes.benefitItemDescription}>{description}</span>
         </div>
      </div>
   );
};

export default BenefitItem;
